var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clock-bgc"},[_c('div',{style:({
      width: _vm.size + 'px',
      height: _vm.size + 'px',
      borderRadius: _vm.borderRadius + '%',
    })}),_vm._l((Array(60)),function(a,i){return _c('div',{key:i,staticClass:"point",style:({
      left: _vm.getX(((6*i) - 90) * (Math.PI / 180)) + 'px',
      top: _vm.getY(((6*i) - 90) * (Math.PI / 180)) + 'px',
      transform: 'rotate('+(6*i)+'deg)',
      transformOrigin: 'top',
      height: (6*i) % 30 === 0 ? '30px' : '10px',
      width: (6*i) % 30 === 0 ? '2px' : '1px',
      backgroundColor: (6*i) % 30 === 0 ? '#d9d9d9' : '#ffffff6e',
    })})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }